import { Button, Image, Stack, Title, TypographyStylesProvider } from '@mantine/core'
import { Link } from '@tanstack/react-router'
import type { BlogEntity, PickedBlogEntity } from '@/interfaces'
import { TwContainer } from '@/lib/components/TwContainer'
import { getFile } from '@/lib/utility'
import { Blogs } from '@/components/blog/Blogs'
import { PostSkeleton } from '@/components/blog/PostSkeleton'

export const Blog = ({ blog, suggestions }: { blog?: BlogEntity; suggestions: Array<PickedBlogEntity> }) => {
	return (
		<section>
			<TwContainer className={'py-16 md:py-24 gap-y-6'} column md>
				{blog ? (
					<>
						<Title className={'px-4'}>{blog.title}</Title>
						<Image src={getFile(blog.image)} alt={blog.title} mah={500} className={'w-full object-center'} radius={'lg'} fit={'cover'} />
						<TypographyStylesProvider dangerouslySetInnerHTML={{ __html: blog.description }} className={'px-2 m-0'} />
					</>
				) : (
					<PostSkeleton />
				)}
				<Button component={Link} my={32} to={'/blog'} mx={'auto'} variant={'brand'}>
					Back to all Posts
				</Button>
				<Stack gap={'xl'} align={'center'} justify={'center'}>
					<Title>You May also Like to Read</Title>
					<Blogs postCardProps={{ className: 'md:w-1/3 w-full' }} blogs={suggestions} className={'flex gap-x-8 gap-y-12 justify-center'} />
				</Stack>
			</TwContainer>
		</section>
	)
}
